const INITIAL_STATE = {
  useHomeAddress: true,
  mailingAddressLine1: '',
  mailingAddressLine2: '',
  mailingAddressLine3: '',
  mailingAddressLine4: '',
  mailingPostcode: '',
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case 'GET_MAILING_ADDRESS_DATA':
      return {
        ...state,
        ...payload,
      };
    case 'SELECT_MAILING_ADDRESS':
      return {
        ...state,
        useHomeAddress: payload,
      };
    case 'GET_ANOTHER_ADDRESS_DATA':
      return {
        ...state,
        payload,
      };
    case 'INITIAL_STATE':
      return {
        useHomeAddress: true,
        mailingAddressLine1: '',
        mailingAddressLine2: '',
        mailingAddressLine3: '',
        mailingAddressLine4: '',
        mailingPostcode: '',
      };
    default:
  }
  return state;
};
